module.exports = __webpack_public_path__ + "static/images/index-default-small1.251ad2c.png";